import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';

export type ShareableResourceType = 'user' | 'project' | 'event' | 'collaboration' | 'offer' | 'feed' | 'post';

@Injectable({
  providedIn: 'root'
})
export class PublicResourceUrlService {
  constructor(
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
  }

  public getUserProfileUrl(userSlug: string): string {
    return this.toAbsolute(this.router.createUrlTree(['/', userSlug, 'profile']).toString());
  }

  public getProjectUrl(ownerSlug: string | null | undefined, projectSlug: string | number): string {
    const normalizedProjectSlug = String(projectSlug);
    const normalizedOwnerSlug = (ownerSlug || '').trim();
    const tree = normalizedOwnerSlug
      ? this.router.createUrlTree(['/', normalizedOwnerSlug, 'garage', normalizedProjectSlug])
      : this.router.createUrlTree(['/garage', normalizedProjectSlug]);

    return this.toAbsolute(tree.toString());
  }

  public getPlaceUrl(slug: string): string {
    return this.toAbsolute(this.router.createUrlTree(['/places', slug]).toString());
  }

  public getEventUrl(eventSlug: string): string {
    return this.toAbsolute(this.router.createUrlTree(['/events', eventSlug]).toString());
  }

  public getCollaborationUrl(ownerSlug: string, collaborationSlug: string | number): string {
    return this.toAbsolute(this.router.createUrlTree(['/', ownerSlug, 'collaborations', String(collaborationSlug)]).toString());
  }

  public getOfferUrl(offerSlugOrId: string | number): string {
    return this.toAbsolute(this.router.createUrlTree(['/marketplace', 'offer', String(offerSlugOrId)]).toString());
  }

  public getFeedUrl(feedSlug: string): string {
    return this.toAbsolute(this.router.createUrlTree(['/feed', feedSlug]).toString());
  }

  public getPostUrl(postId: string | number): string {
    return this.toAbsolute(this.router.createUrlTree(['/posts', String(postId)]).toString());
  }

  public getQrCodeImageUrl(url: string, size: number = 320, errorCorrection: 'L' | 'H' = 'L'): string {
    const normalizedSize = Math.max(160, Math.min(size, 640));
    return `https://api.qrserver.com/v1/create-qr-code/?size=${normalizedSize}x${normalizedSize}&data=${encodeURIComponent(url)}&ecc=${errorCorrection}&qzone=4`;
  }

  private toAbsolute(relativeUrl: string): string {
    const appUrl = (this.document?.location?.origin || 'https://watchthisgarage.com').replace(/\/+$/, '');
    const path = relativeUrl.startsWith('/') ? relativeUrl : `/${relativeUrl}`;

    return `${appUrl}${path}`;
  }
}
